export default __webpack_public_path__ + "static/media/login.433adeec.png";